import { Button, Typography } from "@material-ui/core";
import ActionDialogVariant from "@saleor/components/ActionDialogVariant";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import { useStyles } from "./styles";

interface IDiscardWarnDialogProps {
  isDialogShown: boolean;
  onClose: () => void;
  onRedirect: () => void;
}

const DiscardWarnDialog: FC<IDiscardWarnDialogProps> = ({
  onClose,
  onRedirect,
  isDialogShown
}) => {
  const classes = useStyles({});
  return (
    <ActionDialogVariant
      confirmButtonState="default"
      onClose={onClose}
      onConfirm={onRedirect}
      open={isDialogShown}
      buttonsAlignment="center"
      maxWidth="sm"
      defaultTitle="You have unsaved changes"
      variant="info"
      hideCancelButton
    >
      <Typography className={classes.subContent}>
        <FormattedMessage defaultMessage="Once you exit the page, you won't be able to undo any changes you've made." />
      </Typography>
      <div className={classes.footerButtonsContainer}>
        <Button
          id="dialogStayBtn"
          className={classes.cancelButton}
          variant="contained"
          onClick={onClose}
        >
          Stay
        </Button>
        <Button
          id="dialogLeaveBtn"
          variant="contained"
          className={classes.proceedButton}
          onClick={onRedirect}
        >
          Leave
        </Button>
      </div>
    </ActionDialogVariant>
  );
};

export default DiscardWarnDialog;
